<script setup lang="ts">
  defineProps<{
    icon: string,
  }>()
</script>

<template>
  <div class="space-y-8 py-8 text-center text-gray-500">
    <div class="text-xl">
      <fa-icon
        :icon="icon"
        size="4x" />
    </div>
    <div class="text-xl font-semibold">
      <slot></slot>
    </div>
  </div>
</template>
